import axios from "axios";

export function fetchWorkInProgressReports(params: any = null) {
  return axios.get("/reports/work-in-progress", { params });
}

export function fetchWorkInProgressReport(id: number | string) {
  return axios.get("/reports/work-in-progress/" + id);
}

export function fetchWorkInProgressReportLines(id: number | string, params: any) {
  return axios.get("/reports/work-in-progress/" + id + "/lines", { params });
}

export function downloadExcelExportOfWorkInProgressReport(id: number | string) {
  return axios.get("/reports/work-in-progress/" + id + "/excel", {
    responseType: "blob",
  });
}

export function downloadExcelExportOfWorkInProgressLineItemsReport(id: number | string) {
  return axios.get("/reports/work-in-progress/" + id + "/line-items/excel", {
    responseType: "blob",
  });
}